import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { SimpleSpinner } from 'src/components';
import { useExtension } from 'src/hooks';
import Logo from 'src/images/logos/logo+icon_svg.svg?react';
import ReceiveModalAnimation from 'src/images/lotties/hero-carts.json';

export const ReceiveMobile = () => {
  const { extExists, pingExtension } = useExtension();
  const { cartId } = useParams();
  const [showInstallationHelper, setShowInstallationHelper] =
    useState<boolean>(false);

  useEffect(() => {
    pingExtension();
    // We only want to check for extension existence once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let timeoutId: number | undefined;

    if (!extExists) {
      // Show the loading message after 7 seconds if the extension doesn't exist
      timeoutId = window.setTimeout(() => {
        setShowInstallationHelper(true);
      }, 7000);
    } else {
      // Hide immediately if extension exists
      setShowInstallationHelper(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Ensure hidden on cleanup to avoid lingering state between navigations
      setShowInstallationHelper(false);
    };
  }, [extExists]);

  return (
    <div className='flex h-screen flex-col items-center justify-center bg-primary-dark'>
      <Logo title='Share-A-Cart Logo' className='absolute top-20' />
      <h1 className='heading-700 text-center text-offWhite'>
        Loading cart
        <br />
        <span className='uppercase text-grassGreen'>{cartId}</span>
      </h1>
      <Lottie
        animationData={ReceiveModalAnimation}
        loop={true}
        autoplay={true}
        className='h-56 w-56'
      />
      <div className='mx-auto w-fit py-6'>
        <SimpleSpinner
          customWidth='w-12'
          customHeight='h-12'
          customPosition='block'
          customColor='border-grassGreen'
        />
      </div>
      {showInstallationHelper && (
        <p className='px-4 py-4 text-center text-offWhite'>
          Taking too long? Make sure your Share-A-Cart extension is installed
          and enabled.
          <br />
          <Link
            to='/safari-ios-installation-helper'
            className='text-200 cursor-pointer font-primary font-semibold text-offWhite underline transition-all hover:text-offWhite/70'
            target='_blank'
          >
            Click here to learn more
          </Link>
        </p>
      )}
    </div>
  );
};
